import api from '@/api'

export default {
  all: (filter) => api('get', '/budget', filter),
  create: (data) => api('post', '/budget', data),
  show: (id) => api('get', `/budget/${id}`),
  delete: (id) => api('delete', `/budget/${id}`),
  update: (data) => api('put', `/budget/${data.id}`, data),
  history: (id) => api('get', `/budget/${id}/history`)
}
